import { create } from 'zustand';
import apiClient from '../services/axiosInterceptor';

interface ClassItem {
  id: number;
  class_name: string;
  class_order: number;
  sections: string[];
  created_at: string;
  updated_at: string;
}

interface Pagination {
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

interface ClassesState {
  classes: ClassItem[];
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
  fetchClasses: (schoolId?: string, sessionId?: string, page?: number, limit?: number) => Promise<void>;
}

export const useClassesStore = create<ClassesState>((set) => ({
  classes: [],
  pagination: null,
  loading: false,
  error: null,

  fetchClasses: async (schoolId?: string, sessionId?: string, page = 1, limit = 30) => {
    set({ loading: true, error: null });

    try {
      let url = `classes?page=${page}&limit=${limit}`;
      if (schoolId) {
        url += `&school_id=${schoolId}`;
      }
      if (sessionId) {
        url += `&session_id=${sessionId}`;
      }
      const response = await apiClient.get(url);
      const { classes, pagination } = response.data;

      set({
        classes: Array.isArray(classes) ? classes : [],
        pagination: pagination ?? null,
        loading: false,
      });
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        'Failed to load classes';

      set({
        loading: false,
        error: errorMessage,
      });
    }
  },
}));